import{
  FETCH_WELCOME_WIZARD_CAMPAIGN_REQUEST,
  FETCH_WELCOME_WIZARD_CAMPAIGN_SUCCESS,
  FETCH_WELCOME_WIZARD_CAMPAIGN_FAILURE,
  FETCH_APP_WELCOME_WIZARD_STATUS_REQUEST,
  FETCH_APP_WELCOME_WIZARD_STATUS_SUCCESS,
  FETCH_APP_WELCOME_WIZARD_STATUS_FAILURE,
  FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_REQUEST,
  FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_SUCCESS,
  FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_FAILURE,
  FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_REQUEST,
  FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_SUCCESS,
  FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_FAILURE,
  FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_REQUEST,
  FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_SUCCESS,
  FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_FAILURE,
  FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_REQUEST,
  FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_SUCCESS,
  FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_FAILURE
} from './WelcomeWizardTypes';
import APIManager from '../../ApiManager/ApiManager';
export const fetchWelcomeWizardRequest=()=>{
    return{
        type:FETCH_WELCOME_WIZARD_CAMPAIGN_REQUEST
    };
}
export const fetchWelcomeWizardSuccess=(campaignData)=>{
    return{
        type:FETCH_WELCOME_WIZARD_CAMPAIGN_SUCCESS,
        payload: campaignData
    };
}   
export const fetchWelcomeWizardFailure=(error)=>{
    return{
        type:FETCH_WELCOME_WIZARD_CAMPAIGN_FAILURE,
        payload: error
    };
} 

export const fetchAppWelcomeWizardStatusRequest=()=>{
    return{
        type:FETCH_APP_WELCOME_WIZARD_STATUS_REQUEST
    };
}
export const fetchAppWelcomeWizardStatusSuccess=(statusData)=>{
    return{
        type:FETCH_APP_WELCOME_WIZARD_STATUS_SUCCESS,   
        payload: statusData
    };
}
export const fetchAppWelcomeWizardStatusFailure=(error)=>{
    return{
        type:FETCH_APP_WELCOME_WIZARD_STATUS_FAILURE,
        payload: error
    };
} 

export const fetchAppCampaignWelcomeWizardStatusRequest=()=>{
    return{
        type:FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_REQUEST
    };
}

export const fetchAppCampaignWelcomeWizardStatusSuccess=(statusData)=>{
    return{
        type:FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_SUCCESS,   
        payload: statusData
    };
}

export const fetchAppCampaignWelcomeWizardStatusFailure=(error)=>{
    return{
        type:FETCH_APP_CAMPAIGN_WELCOME_WIZARD_STATUS_FAILURE,
        payload: error
    };
}

export const patchAddAppsWelcomeWizardCampaignRequest=()=>{
    return{
        type:FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_REQUEST
    };
};
export const patchAddAppsWelcomeWizardCampaignSuccess=(data)=>{
    return{
        type:FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_SUCCESS,
        payload: data
    };
};
export const patchAddAppsWelcomeWizardCampaignFailure=(error)=>{
    return{
        type:FETCH_PATCH_ADD_APPS_WELCOME_WIZARD_CAMPAIGN_FAILURE,
        payload: error
    };
};
export const deleteAppWelcomeWizardCampaignRequest=()=>{
    return{
        type:FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_REQUEST
    };
};
export const deleteAppWelcomeWizardCampaignSuccess=()=>{
    return{
        type:FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_SUCCESS,
    };
};
export const deleteAppWelcomeWizardCampaignFailure=(error)=>{
    return{
        type:FETCH_DELETE_APP_WELCOME_WIZARD_CAMPAIGN_FAILURE,
        payload: error
    };
};
export const deleteCampaignNameWelcomeWizardRequest=()=>{
    return{
        type:FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_REQUEST
    };
};
export const deleteCampaignNameWelcomeWizardSuccess=()=>{
    return{
        type:FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_SUCCESS,
    };
};
export const deleteCampaignNameWelcomeWizardFailure=(error)=>{
    return{
        type:FETCH_DELETE_CAMPAIGN_NAME_WELCOME_WIZARD_FAILURE,
        payload: error
    };
};

export const fetchWelcomeWizardCampaign=()=>{
    return async function (dispatch){
        dispatch(fetchWelcomeWizardRequest());      
        try{
            console.log("calling API for portfolioId:", sessionStorage.getItem("portfolioId"));
            const data= await APIManager.getWelcomeWizardCampaigns(sessionStorage.getItem("portfolioId"));
            console.log("API response data:", data);
            dispatch(fetchWelcomeWizardSuccess(data));
        }   catch (error){
            dispatch(fetchWelcomeWizardFailure(error.message));
        }
    };
}

export const fetchAppWelcomeWizardStatus=(payloadData)=>{
    return async function (dispatch){
        dispatch(fetchAppWelcomeWizardStatusRequest());     
        try{
            console.log("insoide fetchAppWelcomeWizardStatus with payloadData:", payloadData);
            const data= await APIManager.postAppWelcomeWizardCampaign(sessionStorage.getItem("portfolioId"), payloadData);
            dispatch(fetchAppWelcomeWizardStatusSuccess(data));
        }   catch (error){
            dispatch(fetchAppWelcomeWizardStatusFailure(error.message));
        }
    };
}

export const fetchAppCampaignWelcomeWizardStatus=(campaignName)=>{
    return async function (dispatch){
        dispatch(fetchAppCampaignWelcomeWizardStatusRequest());     
        try{
            const portfolioId= sessionStorage.getItem("portfolioId");
            const data= await APIManager.getAppsForCampaign(portfolioId, campaignName);     
            dispatch(fetchAppCampaignWelcomeWizardStatusSuccess(data));
        }   catch (error){
            dispatch(fetchAppCampaignWelcomeWizardStatusFailure(error.message));
        }
    };
}

export const postCreateWelcomeWizardCampaign=(campaignData)=>{
    return async function (dispatch){
        dispatch(fetchWelcomeWizardRequest())
        try{
            await APIManager.postCreateWelcomeWizardCampaigns(sessionStorage.getItem("portfolioId"), campaignData);
            dispatch(fetchWelcomeWizardCampaign());
        }   catch (error){
            dispatch(fetchWelcomeWizardFailure(error.message));
        }
    };
}

export const patchAddAppsWelcomeWizardCampaign=(campaignName, appData)=>{
    return async function (dispatch){   
        dispatch(patchAddAppsWelcomeWizardCampaignRequest());   
        try{
            const portfolioId= sessionStorage.getItem("portfolioId");
            const data= await APIManager.patchAddAppsWelcomeWizardCampaign(portfolioId, campaignName, appData);
            dispatch(patchAddAppsWelcomeWizardCampaignSuccess(data));
            dispatch(fetchAppCampaignWelcomeWizardStatus(campaignName));
        }   catch (error){
            dispatch(patchAddAppsWelcomeWizardCampaignFailure(error.message));
        }
    };
}

export const reorderAppsWelcomeWizardCampaign=(campaignName, appData)=>{
    return async function (dispatch){
        dispatch(patchAddAppsWelcomeWizardCampaignRequest());
        try{
            const portfolioId= sessionStorage.getItem("portfolioId");
            const data= await APIManager.reorderAppsForWelcomeWizardCampaign(portfolioId, campaignName, appData);
            dispatch(patchAddAppsWelcomeWizardCampaignSuccess(data));
            dispatch(fetchAppCampaignWelcomeWizardStatus(campaignName));
        }   catch (error){
            dispatch(patchAddAppsWelcomeWizardCampaignFailure(error.message));
        }
    };
}

export const deleteAppWelcomeWizardCampaign=(campaignName, packageId)=>{
    return async function (dispatch){   
        dispatch(deleteAppWelcomeWizardCampaignRequest());  
        try{
            const portfolioId= sessionStorage.getItem("portfolioId");
            await APIManager.deleteAppFromWelcomeWizardCampaign(portfolioId, campaignName, packageId);
            dispatch(deleteAppWelcomeWizardCampaignSuccess());
            dispatch(fetchAppCampaignWelcomeWizardStatus(campaignName));
        }   catch (error){
            dispatch(deleteAppWelcomeWizardCampaignFailure(error.message));
        }
    };
}

export const deleteCampaignNameWelcomeWizard=(campaignName)=>{
    return async function (dispatch){   
        dispatch(deleteCampaignNameWelcomeWizardRequest());  
        try{
            const portfolioId= sessionStorage.getItem("portfolioId");
            await APIManager.deleteWelcomeWizardCampaign(portfolioId, campaignName);
            dispatch(deleteCampaignNameWelcomeWizardSuccess());
            dispatch(fetchWelcomeWizardCampaign());
        }   catch (error){
            dispatch(deleteCampaignNameWelcomeWizardFailure(error.message));
        }
    };
}